/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LiveScorecardFiltersPlayersQueryVariables = {|
  eventId: string
|};
export type LiveScorecardFiltersPlayersQueryResponse = {|
  +playersForLiveRound: ?$ReadOnlyArray<?{|
    +id: string,
    +fullName: ?string,
  |}>,
  +myPlayersForLiveRound: ?$ReadOnlyArray<?{|
    +id: string,
    +fullName: ?string,
  |}>,
  +exportedLineupSetsForPgaEvent: ?$ReadOnlyArray<?{|
    +id: string,
    +greenMachineSession: {|
      +slate: {|
        +suffix: ?string
      |}
    |},
    +buildNum: number,
  |}>,
|};
export type LiveScorecardFiltersPlayersQuery = {|
  variables: LiveScorecardFiltersPlayersQueryVariables,
  response: LiveScorecardFiltersPlayersQueryResponse,
|};
*/


/*
query LiveScorecardFiltersPlayersQuery(
  $eventId: ID!
) {
  playersForLiveRound(eventId: $eventId) {
    id
    fullName
  }
  myPlayersForLiveRound(eventId: $eventId) {
    id
    fullName
  }
  exportedLineupSetsForPgaEvent(pgaEventId: $eventId) {
    id
    greenMachineSession {
      slate {
        suffix
        id
      }
      id
    }
    buildNum
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": (v1/*: any*/),
  "concreteType": "PGATourPlayerType",
  "kind": "LinkedField",
  "name": "playersForLiveRound",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": (v1/*: any*/),
  "concreteType": "PGATourPlayerType",
  "kind": "LinkedField",
  "name": "myPlayersForLiveRound",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "pgaEventId",
    "variableName": "eventId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suffix",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buildNum",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveScorecardFiltersPlayersQuery",
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "GreenMachineLineupSetType",
        "kind": "LinkedField",
        "name": "exportedLineupSetsForPgaEvent",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GreenMachineSessionType",
            "kind": "LinkedField",
            "name": "greenMachineSession",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateType",
                "kind": "LinkedField",
                "name": "slate",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveScorecardFiltersPlayersQuery",
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "GreenMachineLineupSetType",
        "kind": "LinkedField",
        "name": "exportedLineupSetsForPgaEvent",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GreenMachineSessionType",
            "kind": "LinkedField",
            "name": "greenMachineSession",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateType",
                "kind": "LinkedField",
                "name": "slate",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd8489d5e218a1a3e43076dd61653587",
    "id": null,
    "metadata": {},
    "name": "LiveScorecardFiltersPlayersQuery",
    "operationKind": "query",
    "text": "query LiveScorecardFiltersPlayersQuery(\n  $eventId: ID!\n) {\n  playersForLiveRound(eventId: $eventId) {\n    id\n    fullName\n  }\n  myPlayersForLiveRound(eventId: $eventId) {\n    id\n    fullName\n  }\n  exportedLineupSetsForPgaEvent(pgaEventId: $eventId) {\n    id\n    greenMachineSession {\n      slate {\n        suffix\n        id\n      }\n      id\n    }\n    buildNum\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'da091e940c0e66f7b9074fcd63711106';

module.exports = node;
